import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'accountNumberFormat',
  standalone: false // Set to true if using standalone components
})
export class AccountNumberFormatPipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    
    // Remove any existing dashes
    const accountNumberWithNoDash = value.replace(/-/g, '');
     // Don't add a dash for masked account numbers (e.g. Broadcom '*****')
    if (accountNumberWithNoDash.includes('*')) {
      return accountNumberWithNoDash;
    }
    
    // Don't format if less than 4 digits
    if (accountNumberWithNoDash.length <= 4) {
      return accountNumberWithNoDash;
    }
    
    // Add dash after 4 digits
    return `${accountNumberWithNoDash.substring(0, 4)}-${accountNumberWithNoDash.substring(4)}`;
  }
}